<div *ngIf="subscriptionExist && isComponentInitialized" style="height: 100%">
    <mat-tab-group mat-stretch-tabs (selectedTabChange)="onSelectTab()" #matTabGroup>
        <mat-tab>
            <ng-template mat-tab-label>
                <span translate>SUBSCRIPTIONS_ACCOUNTS.PRODUCT_INFO</span>
            </ng-template>
            <mat-card style="height: 100%">
                <mat-card-content>
                    <div class="flex-column">
                        <div style="display: flex; justify-content: space-between; padding-bottom: 1.2rem">
                            <div class="titleTabContent" style="justify-content: flex-start">
                                <span translate>M_SUB_INF_PDT_PURCHASED</span><br />
                            </div>
                            <div>
                                <button
                                    *ngIf="this.storeRolesService?.IsInternal || this.subscription?.Mode == 1"
                                    mat-flat-button
                                    color="primary"
                                    [disabled]="this.productID.length == 0"
                                    class="button-icon-text"
                                    style="padding: 0 20px"
                                    (click)="redirectToSubscriptionManagementPage()"
                                >
                                    <mat-icon>update</mat-icon>
                                    <span matTooltip="{{ 'M_SUB_INF_TOOLTIP_1' | translate }}" matTooltipClass="tooltip-layout" translate
                                        >M_SUB_INF_UPDATE</span
                                    >
                                </button>
                            </div>
                        </div>

                        <div [class]="this.smallScreen ? 'verticalDisplay' : 'horizontalDisplay'">
                            <div [class]="this.smallScreen ? 'columnOnlyOne' : 'firstColumn'">
                                <mat-form-field appearance="outline" class="mff-main-data">
                                    <mat-label translate>EDIT_SUBSCRIPTION.DESC</mat-label>
                                    <input matInput [(ngModel)]="model.Description" name="Description" />
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="mff-main-data">
                                    <mat-label><span translate>EDIT_SUBSCRIPTION.SUBKEY_CODE</span></mat-label>
                                    <input
                                        matInput
                                        [ngModel]="model.SubscriptionKey"
                                        name="SubcriptionKey"
                                        #SubscriptionKeyInput
                                        disabled
                                    />
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="mff-main-data">
                                    <mat-label translate>EDIT_SUBSCRIPTION.CREATION_DATE</mat-label>
                                    <input matInput [matDatepicker]="cD" [ngModel]="model.CreationDate" name="CreationDate" disabled />
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="mff-main-data">
                                    <mat-label translate>USER_FORM.COUNTRY</mat-label>
                                    <input matInput [ngModel]="subscriptionTokenInfo.country" name="country" disabled />
                                </mat-form-field>
                            </div>

                            <div [class]="this.smallScreen ? 'columnOnlyOne' : 'secondColumn'">
                                <mat-form-field appearance="outline" class="mff-main-data">
                                    <mat-label translate>L_CONFIGURATION</mat-label>
                                    <input matInput [ngModel]="configuration" name="Configuration" disabled />
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    class="mff-main-data"
                                    [hidden]="!existsMasterSubKey"
                                    (click)="onClickSubKey(model.MasterSubscriptionKey)"
                                    matTooltip="{{ 'INCIDENT.PLC_HLD_2' | translate }}"
                                    matTooltipClass="tooltip-layout"
                                >
                                    <mat-label translate>LEADING_COMPANY_CODE</mat-label>
                                    <input
                                        matInput
                                        style="cursor: pointer"
                                        [ngModel]="model.MasterSubscriptionKey"
                                        name="Configuration"
                                        disabled
                                    />
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="mff-main-data" *ngIf="subscription.InstanceOrigin == 'ONPREM'">
                                    <mat-label translate>COMMONS.INSTANCE_ONPREMISES</mat-label>
                                    <input matInput [ngModel]="instanceDescription" name="Instance OnPremises" disabled />
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="mff-main-data" *ngIf="subscription.InstanceOrigin == 'MW'">
                                    <mat-label translate>COMMONS.INSTANCE_MAGOWEB</mat-label>
                                    <input matInput [ngModel]="instanceDescription" name="MagoWeb Instance" disabled />
                                </mat-form-field>
                                <div *ngIf="this.productID == 'MW' && this.isUserAdmin">
                                    <button mat-button color="primary" (click)="resendMagoWebInformationMail()">
                                        <span translate>COMMONS.RESEND_MAGOWEBINFO_MAIL</span> <mat-icon></mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!--bottoni -->
                        <div style="display: flex; flex-direction: column; width: 50%; align-items: flex-end; width: 100%">
                            <div class="button-alignment">
                                <button
                                    mat-flat-button
                                    color="primary"
                                    class="left"
                                    (click)="cancel()"
                                    [disabled]="this.model.Description === this.copyOfModel.Description"
                                >
                                    <span translate>B_CANCEL</span>
                                </button>
                                <button
                                    mat-flat-button
                                    (click)="submitSubscription()"
                                    color="primary"
                                    [disabled]="this.model.Description === this.copyOfModel.Description"
                                >
                                    <span translate>B_SAVE</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <span translate>INVOICING_DATA.SUBSCRIBER_MASTER_DATA</span>
            </ng-template>
            <ms-dati-fatturazione
                [setReadOnly]="true"
                [isSubNfs]="isSubNfs"
                [showPartnerCodeField]="true"
                [imInSubscriptionsManagement]="true"
                [subscriptionKey]="this.currentsubscriptionKey"
                [showOnlySubscriberMasterData]="false"
                [isUpdate]=""
            >
            </ms-dati-fatturazione>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <span translate>M_SUB_MNG_TOOLTIP_2</span>
            </ng-template>
            <mat-drawer-container autosize style="height: 550px" *ngIf="!hideInfo; else other_content">
                <mat-drawer #drawer mode="side" position="end" style="width: 500px">
                    <tb-list-users-associated
                        *ngIf="canShowAccountDetail"
                        [accountDetail]="accountDetail"
                        [disableCheckbox]="disableCheckbox"
                        [currentsubscriptionKey]="this.currentsubscriptionKey"
                        [calledBySubsriptionManagement]="true"
                        [hideInfo]="hideInfo"
                        (close)="closeDrawer($event)"
                        (rolesSaved)="setRoles($event)"
                    >
                    </tb-list-users-associated>
                    <mat-card style="border-radius: 0; min-height: 100%; position: relative" *ngIf="!canShowAccountDetail">
                        <div *ngIf="showChoices">
                            <mat-radio-group class="example-radio-group" [(ngModel)]="choice" (change)="showChoice($event)">
                                <div class="flex-row">
                                    <mat-radio-button class="example-radio-button" value="a">
                                        <span translate> M_SUB_INF_CHOOSE_OPT_1</span>
                                    </mat-radio-button>
                                    <span
                                        class="material-icons info-icon"
                                        matTooltip="{{ 'M_SUB_MNG_TOOLTIP_5' | translate }}"
                                        matTooltipClass="tooltip-layout"
                                    >
                                        info
                                    </span>
                                </div>
                                <div class="flex-row">
                                    <mat-radio-button class="example-radio-button" value="b">
                                        <span translate> M_SUB_INF_CHOOSE_OPT_2</span>
                                    </mat-radio-button>
                                    <span
                                        class="material-icons info-icon"
                                        matTooltip="{{ 'M_SUB_MNG_TOOLTIP_6' | translate }}"
                                        matTooltipClass="tooltip-layout"
                                    >
                                        info
                                    </span>
                                </div>
                                <div class="flex-row">
                                    <mat-radio-button class="example-radio-button" value="c">
                                        <span translate> M_SUB_INF_CHOOSE_OPT_3</span>
                                    </mat-radio-button>
                                    <span
                                        class="material-icons info-icon"
                                        matTooltip="{{ 'M_SUB_MNG_TOOLTIP_7' | translate }}"
                                        matTooltipClass="tooltip-layout"
                                        >info</span
                                    >
                                </div>
                            </mat-radio-group>
                            <div class="close-drawer">
                                <button mat-flat-button color="primary" (click)="closeDrawer()">
                                    <span translate>M_CLOSE</span>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="!showChoices">
                            <mat-card-title *ngIf="choice === 'a'" class="title" translate> M_SUB_INF_CHOOSE_OPT_1 </mat-card-title>
                            <mat-card-title *ngIf="choice === 'b'" class="title" translate> M_SUB_INF_CHOOSE_OPT_2 </mat-card-title>
                            <mat-card-title *ngIf="choice === 'c'" class="title" translate> M_SUB_INF_CHOOSE_OPT_3 </mat-card-title>
                            <form [formGroup]="firstFormGroup" *ngIf="choice !== 'c'">
                                <mat-card-subtitle style="font-size: 0.89rem !important" *ngIf="choice === 'a'" translate
                                    >M_SUB_INF_ENTER_NEW_ACC
                                </mat-card-subtitle>
                                <mat-card-subtitle style="font-size: 0.89rem !important" *ngIf="choice === 'b'" translate>
                                    M_SUB_INF_ENTER_ACC
                                </mat-card-subtitle>
                                <div class="flex-column">
                                    <mat-form-field appearance="outline" style="margin: 0 !important; font-size: 12px !important">
                                        <mat-label translate>EDIT_SUBSCRIPTION.ACC</mat-label>
                                        <input matInput adminAutoFocus formControlName="firstValue" required />
                                        <mat-error *ngIf="firstFormGroup.controls['firstValue'].invalid"
                                            >{{ getErrorMessage() }}
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" style="margin: 0 !important; font-size: 12px !important">
                                        <mat-label translate>EDIT_SUBSCRIPTION.EXPIRATION_DATE</mat-label>
                                        <input
                                            matInput
                                            [min]="minDate"
                                            [matDatepicker]="eD"
                                            [ngModelChange]="eDateValueChange2(eD)"
                                            [(ngModel)]="secondValue"
                                            [ngModelOptions]="{ standalone: true }"
                                            name="ExpirationDate"
                                            readonly="true"
                                        />
                                        <mat-datepicker-toggle matSuffix [for]="eD"></mat-datepicker-toggle>
                                        <mat-datepicker #eD disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </form>
                            <form [formGroup]="secondFormGroup" *ngIf="showAll">
                                <div class="flex-column">
                                    <mat-form-field appearance="outline" style="margin: 0 !important; font-size: 12px !important">
                                        <mat-label translate>DIALOG.dialogPlaceHolderFullName</mat-label>
                                        <input matInput adminAutoFocus formControlName="fullNameValue" required />
                                        <mat-error *ngIf="secondFormGroup.controls['fullNameValue'].invalid"
                                            >{{ getErrorMessage() }}
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" style="margin: 0 !important; font-size: 12px !important">
                                        <mat-label translate>DIALOG.dialogPlaceHolderEmail</mat-label>
                                        <input
                                            matInput
                                            formControlName="emailValue"
                                            onCopy="return false"
                                            onDrag="return false"
                                            onDrop="return false"
                                            onPaste="return false"
                                            required
                                        />
                                        <mat-error *ngIf="secondFormGroup.controls['emailValue'].invalid"
                                            >{{ getErrorMessage() }}
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" style="margin: 0 !important; font-size: 12px !important">
                                        <mat-label translate>ACCOUNT_CREATE.VERIFY_MAIL</mat-label>
                                        <input
                                            matInput
                                            formControlName="verifyEmailValue"
                                            onCopy="return false"
                                            onDrag="return false"
                                            onDrop="return false"
                                            onPaste="return false"
                                            required
                                        />
                                        <mat-error *ngIf="secondFormGroup.controls['verifyEmailValue'].invalid"
                                            >{{ getErrorMessage() }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </form>
                            <div *ngIf="choice === 'c' && !accountListLoading">
                                <ms-account-list-table
                                    [userAdmins]="userAdmins"
                                    [accountFound]="accountFound"
                                    [dataSourceAccounts]="dataSourceAccounts_2"
                                    [model]="model"
                                    [searchAccountText]="searchAccountText"
                                    [showFilterOptions]="showFilterOptions"
                                    [notChoosingListOfAccounts]="false"
                                    [minDate]="minDate"
                                    (showAssociateAccount)="showAssociateAccount()"
                                    (doSomething)="doSomething($event)"
                                    (changeBackground)="changeBackground($event)"
                                    (removeRow)="removeRow($event)"
                                    (setAccountName)="setAccountName($event)"
                                    (setListAccounts)="setListAccounts($event)"
                                    (setDate)="setDate($event)"
                                >
                                </ms-account-list-table>
                            </div>
                            <div style="display: flex; justify-content: flex-end; margin-top: 10px">
                                <button mat-flat-button color="primary" class="left" (click)="backFromDrawer()">
                                    <span translate>COMMONS.BACK</span>
                                </button>
                                <button
                                    mat-flat-button
                                    color="primary"
                                    *ngIf="choice === 'a'"
                                    (click)="createAccountOrJustAssociate()"
                                    [disabled]="isInvalid1()"
                                >
                                    <span translate> M_SUB_INF_BTN_CREATE</span>
                                </button>
                                <button
                                    mat-flat-button
                                    color="primary"
                                    *ngIf="choice === 'b'"
                                    (click)="createAccountOrJustAssociate()"
                                    [disabled]="isInvalid2()"
                                >
                                    <span translate> M_SUB_INF_BTN_ASS</span>
                                </button>
                                <button
                                    mat-flat-button
                                    color="primary"
                                    [disabled]="listAccounts.length === 0"
                                    *ngIf="choice === 'c' && dataSourceAccounts_2.data.length > 0"
                                    (click)="createAccountOrJustAssociate()"
                                >
                                    <span translate> M_SUB_INF_BTN_ASS</span>
                                </button>
                            </div>
                        </div>
                    </mat-card>
                </mat-drawer>
                <ms-account-list-table
                    [userAdmins]="userAdmins"
                    [accountFound]="accountFound"
                    [dataSourceAccounts]="dataSourceAccounts"
                    [model]="model"
                    [searchAccountText]="searchAccountText"
                    [showFilterOptions]="showFilterOptions"
                    [notChoosingListOfAccounts]="true"
                    [minDate]="minDate"
                    (showAssociateAccount)="showAssociateAccount()"
                    (applyAccountSearch)="applyAccountSearch($event)"
                    (doSomething)="doSomething($event)"
                    (changeBackground)="changeBackground($event)"
                    (removeRow)="removeRow($event)"
                    (setAccountName)="setAccountName($event)"
                    (setDate)="setDate($event)"
                >
                </ms-account-list-table>
            </mat-drawer-container>
            <ng-template #other_content>
                <mat-card style="height: 100%">
                    <mat-card-content style="display: flex; flex-direction: column">
                        <div class="titleTabContent title-alignment">
                            <span translate>M_SUB_MNG_TOOLTIP_2</span>
                        </div>
                        <p>{{ associatedAccountInfo }}</p>
                    </mat-card-content>
                </mat-card>
            </ng-template>
        </mat-tab>

        <!-- <mat-tab *ngIf="isNotInternal"> -->
        <!-- Nessun controllo perchè lo ha chiesto Anna -->
        <mat-tab>
            <ng-template mat-tab-label>
                <span translate>L_ADV_CONFIG</span>
            </ng-template>
            <ms-advanced-settings
                [subscription]="subscription"
                [model]="model"
                [copyOfModel]="copyOfModel"
                [currentsubscriptionKey]="currentsubscriptionKey"
                [isNotInternal]="isNotInternal"
                [isDevOpsOrSysAdmin]="isDevOpsOrSysAdmin"
                [advancedSettings]="advancedSettings"
                [copyOfAdvancedSettings]="copyOfAdvancedSettings"
                [showAdvancedSettings]="showAdvancedSettings"
                [showEmailSection]="showEmailSection"
                [existsAuditing]="existsAuditing"
                [existsSecurity]="existsSecurity"
                [existsVisibility]="existsVisibility"
                [existsCGM]="existsCGM"
                [isMoving]="isMoving"
                [language]="language"
                [productID]="subscription.InstanceOrigin"
                (descriptionChanged)="setDescription($event)"
                (closeDrawer)="closeDrawer()"
                *ngIf="loadAdvancedSettingsTab"
            ></ms-advanced-settings>
        </mat-tab>

        <mat-tab *ngIf="this.havePermission && !this.existsMasterSubKey">
            <ng-template mat-tab-label>
                <span translate>SUBSCRIPTIONS_ACCOUNTS.MANAGE_MULTICOMPANY</span>
                <br />
                <br />
            </ng-template>
            <ms-multicompany
                [currentsubscriptionKey]="this.currentsubscriptionKey"
                [currentsubscriptionDescri]="model.Description"
                [productID]="this.productID"
                [subMode]="this.model.SubscriptionToken.mode"
                [havePermission]="this.havePermission"
                (subKey)="onClickSubKey($event)"
            >
            </ms-multicompany>
        </mat-tab>
    </mat-tab-group>
</div>
<div *ngIf="loading">
    <tb-loading></tb-loading>
</div>
